module.exports = __webpack_public_path__ + "static/img/Pictures for the Main Cover.74c86c58.gif";